import VoiceTrainManagement from "./voice-train-management.page";

export default VoiceTrainManagement;
